<template>
  <vx-input-group append-classes="i8n-input justify-bottom">
    <vs-input
      :label="label"
      :placeholder="placeholder"
      v-model="i8nContent"
      class="w-full"
      name="item-name"
      v-validate="'required'"
    />

    <div slot="append">
      <vs-dropdown vs-trigger-click class="cursor-pointer items-per-page-handler">
        <div
          style="padding: 0.8rem !important"
          class="
            ml-2
            mr-2
            border border-solid
            d-theme-border-grey-light
            rounded-full
            d-theme-dark-bg
            cursor-pointer
            flex
            items-center
            justify-between
            font-medium
          "
        >
          <img class="h-4 w-5" :src="i18n_locale_img" :alt="locale" />
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
        </div>
        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
        <vs-dropdown-menu class="w-48">
          <vs-dropdown-item @click="updateLocale('eng')">
            <img class="h-4 w-5 mr-1" src="@/assets/images/flags/eng.png" alt="eng" />
            &nbsp;English
          </vs-dropdown-item>
          <vs-dropdown-item @click="updateLocale('dan')">
            <img class="h-4 w-5 mr-1" src="@/assets/images/flags/dan.png" alt="eng" />
            &nbsp;Danish
          </vs-dropdown-item>
          <vs-dropdown-item @click="updateLocale('swe')">
            <img class="h-4 w-5 mr-1" src="@/assets/images/flags/swe.png" alt="eng" />
            &nbsp;Swedish
          </vs-dropdown-item>
          <vs-dropdown-item @click="updateLocale('nor')">
            <img class="h-4 w-5 mr-1" src="@/assets/images/flags/nor.png" alt="eng" />
            &nbsp;Norwegian
          </vs-dropdown-item>
          <vs-dropdown-item @click="updateLocale('fin')">
            <img class="h-4 w-5 mr-1" src="@/assets/images/flags/fin.png" alt="eng" />
            &nbsp;Finnish
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </vx-input-group>
</template>

<script>
import VxImportGroup from "@/components/vx-input-group/VxInputGroup";

export default {
  name: "i8n-input",
  components: {
    VxImportGroup,
  },
  props: {
    label: String,
    placeholder: String,
    content: [String, Object],
  },
  data() {
    return {
      locale: "eng",
      i8nContent: "",
    };
  },
  watch: {
    locale() {
      this.i8nContent = this.content[this.locale];
    },
    i8nContent() {
      let clonedContent = { ...this.content };
      clonedContent[this.locale] = this.i8nContent;

      this.$emit("update:content", clonedContent);
    },
    content() {
      this.i8nContent = this.content[this.locale];
    },
  },
  computed: {
    i18n_locale_img() {
      return require(`@/assets/images/flags/${this.locale}.png`);
    },
  },
  methods: {
    updateLocale(locale) {
      this.locale = locale;
    },
  },
  mounted() {
    let contentType = typeof this.content;
    if (contentType === "string" || contentType === "undefined" || this.content === null) {
      let newContent = {
        eng: "",
        dan: "",
        swe: "",
        nor: "",
        fin: "",
      };
      this.$emit("update:content", newContent);

      this.i8nContent = "";

      return;
    }

    this.i8nContent = this.content[this.locale];

    this.$root.$on("changedLocale", this.updateLocale);
  },
};
</script>
<style lang="scss">
.vs-dropdown-menu.w-48 {
  z-index: 1000000;
}

.i8n-input.justify-bottom {
  align-items: flex-end;
}
</style>